import React, { useEffect, useState, forwardRef, useImperativeHandle } from "react";
import DropDown from "sr/helpers/ui-components/DropDown.tsx";
import { FormattedMessage } from "react-intl";
import { getAreaType } from "sr/utils/api/masterData/getAreaType";

type Props = {
  data: { area_type?: string };
  HandleDataProps: (payload: { area_type: string }) => void;
  externalErrorId?: string;
};

const RequirementAreaTypeChange = forwardRef(({ data, HandleDataProps, externalErrorId }: Props, ref) => {
  const [areaType, setAreaType] = useState("");
  const [errorId, setErrorId] = useState<string>("");
  const [options, setOptions] = useState<{ value: string; label: string }[]>([]);

  useEffect(() => {
    setAreaType(data?.area_type || "");
  }, [data?.area_type]);

  useEffect(() => {
    const load = async () => {
      try {
        const res = await getAreaType();
        if (res?.success && Array.isArray(res.data)) {
          const mapped = res.data.map((item: any) => ({
            value: item.value,
            label: item.label,
          }));
          setOptions(mapped);
        }
      } catch {}
    };
    load();
  }, []);

  useEffect(() => {
    HandleDataProps({ area_type: areaType });
  }, [areaType]);

  useImperativeHandle(ref, () => ({
    validateData: () => {
      if (!areaType?.trim()) {
        setErrorId('INPUT.VALIDATION.REQUIREMENT.AREATYPE');
        return false;
      }
      setErrorId("");
      return true;
    },
    submitForm: () => ({ area_type: areaType }),
  }));

  return (
    <div>
      <p className="pt-4 text-base">Area Type</p>
      <DropDown
        value={areaType}
        onChange={(e) => setAreaType(e.target.value)}
        name="area_type"
        className="h-11 mt-2 border border-zinc-800 rounded-lg"
        error={externalErrorId || errorId}
      >
        <option value="">Select Area Type</option>
        {options.map((opt, idx) => (
          <option key={idx} value={opt.value}>
            <FormattedMessage id={opt.label} defaultMessage={opt.label} />
          </option>
        ))}
      </DropDown>
    </div>
  );
});

export default RequirementAreaTypeChange;
